var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 15,
    viewBox: "0 0 33 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 15,
    fill: "#1873B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4164 8.01752L12.4139 3.12053L11.0151 4.54952L17.4465 10.8454L23.7423 4.41392L22.3133 3.01506L17.4164 8.01752Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow1);
export default __webpack_public_path__ + "static/media/down-arrow1.cb65d4bc9492b2fcef14ea42e10b3482.svg";
export { ForwardRef as ReactComponent };